import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { typography, spacing, responsive, colors } from "../../../design/tokens";

export function WelcomeSEOText() {
  const isCompactView = useIsCompactView();

  return (
    <div className="w-full bg-light-surface-primary dark:bg-dark-surface-primary relative overflow-hidden">
      {/* Subtle background gradient effect */}
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at center top, rgba(31, 71, 136, 0.08), transparent 60%)',
        }}
      />

      {/* Content container */}
      <div
        className={`relative z-10 ${spacing.maxWidth.content} mx-auto ${
          responsive("px-8 py-16", "px-8 py-24", isCompactView)
        }`}
      >
        {/* Text content */}
        <div>
          {/* Hero-style headline */}
          <h2
            className={`${
              isCompactView
                ? "text-[clamp(1.75rem,8vw,2.625rem)]"
                : "text-[clamp(2rem,4vw,3rem)]"
            } ${typography.weight.bold} text-center ${typography.leading['1.15']} ${colors.text.primary} mb-12 whitespace-nowrap`}
          >
            How Darvin Works
          </h2>

          {/* Body paragraphs */}
          <div className="space-y-6 text-justify">
            <p
              className={`${
                isCompactView ? "text-[16px]" : "text-[17px]"
              } ${colors.text.secondary} leading-[1.7]`}
            >
              Darvin empowers you to build <strong className={colors.text.primary}>app-store-ready native mobile apps for
              Android and iOS and Progressive Web Apps (PWAs)</strong> — all from simple text
              prompts. Using Flutter code (not web wrappers or static templates), each
              project delivers smooth performance, responsive layouts and
              production-quality builds.
            </p>
            <p
              className={`${
                isCompactView ? "text-[16px]" : "text-[17px]"
              } ${colors.text.secondary} leading-[1.7]`}
            >
              For creators, startups, SMBs and educators, Darvin automates your entire Flutter development workflow: UI generation,
              logic, preview, and full code export.
            </p>
            <p
              className={`${
                isCompactView ? "text-[16px]" : "text-[17px]"
              } ${colors.text.secondary} leading-[1.7]`}
            >
              Experience true <strong className={colors.text.primary}>no-code + low-code
              Flutter app development</strong> with Darvin's intelligent agent, powered by the
              latest large-language models — optimized for native mobile and web-based
              experiences.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
